<template>
  <CRow class="stat-cards-row">
    <!-- ========================================== -->
    <!-- باکس ۱: مراجعات امروز -->
    <!-- ========================================== -->
    <CCol :sm="6" :lg="4">
      <CCard class="stat-card stat-card-primary">
        <CCardBody class="text-center">
          <div class="stat-icon">📅</div>
          <div class="stat-number">{{ get_currency(info.today_visit) }}</div>
          <div class="stat-label">{{ $t('today_visit') }}</div>
        </CCardBody>
      </CCard>
    </CCol>

    <!-- ========================================== -->
    <!-- باکس ۲: مراجعات فردا -->
    <!-- ========================================== -->
    <CCol :sm="6" :lg="4">
      <CCard class="stat-card stat-card-info">
        <CCardBody class="text-center">
          <div class="stat-icon">⏰</div>
          <div class="stat-number">{{ get_currency(info.tomorrow_reserve) }}</div>
          <div class="stat-label">{{ $t('tomorrow_visit') }}</div>
        </CCardBody>
      </CCard>
    </CCol>

    <!-- ========================================== -->
    <!-- باکس ۳: اعتبار پیامک (با دکمه شارژ) -->
    <!-- ========================================== -->
    <CCol v-if="$i18n.locale == 'fa'" :sm="6" :lg="4">
      <CCard class="stat-card stat-card-sms">
        <CCardBody class="text-center sms-card-body">
          <div class="sms-header">

          </div>

          <div class="stat-number sms-number">
            {{ Number(info.sms_credit || 0).toLocaleString('fa-IR') }}
          </div>
          <div class="stat-label">{{ $t('sms_credit') }}
            <span :class="['sms-status-badge', smsStatusClass]">
              {{ smsStatusLabel }}
            </span>
          </div>

          <!-- ===== دکمه شارژ پیامک ===== -->
          <button class="btn-charge-sms" @click="goToSmsCharge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 4v16m8-8H4" stroke-linecap="round"/>
            </svg>
            شارژ پیامک
          </button>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'WidgetsDropdown',

  props: {
    info: {
      type: Object,
      required: true,
      default: () => ({
        today_visit: 0,
        tomorrow_reserve: 0,
        sms_credit: 0
      })
    }
  },

  computed: {
    // ===== وضعیت اعتبار پیامک =====
    smsStatusClass() {
      const credit = Number(this.info.sms_credit || 0);
      if (credit <= 0) return 'sms-status-danger';
      if (credit < 100) return 'sms-status-warning';
      return 'sms-status-success';
    },

    smsStatusLabel() {
      const credit = Number(this.info.sms_credit || 0);
      if (credit <= 0) return 'اعتبار تمام شده';
      if (credit < 100) return 'اعتبار کم';
      return 'فعال';
    }
  },

  methods: {
    // ===== رفتن به صفحه شارژ پیامک =====
    goToSmsCharge() {
      // اگر از vue-router استفاده می‌کنید:
      this.$router.push('/dashboard/sms-credits');

      // اگر از router-link یا لینک معمولی استفاده می‌کنید:
      // window.location.href = '/admin/sms-credits';
    }
  }
};
</script>

<style scoped>
/* ========================================== */
/* ردیف کارت‌ها */
/* ========================================== */
.stat-cards-row {
  margin-left: -10px;
  margin-right: -10px;
}

.stat-cards-row > * {
  padding-left: 10px;
  padding-right: 10px;
}

/* ========================================== */
/* کارت‌های عمومی */
/* ========================================== */
.stat-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transition: transform 0.3s, box-shadow 0.3s;
  margin-bottom: 1.2rem;
  overflow: hidden;
  position: relative;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
}

/* ===== گرادیانت‌ها ===== */
.stat-card-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.stat-card-info {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.stat-card-sms {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

/* ===== بدنه کارت ===== */
.stat-card .card-body {
  padding: 1.8rem 1rem 1.4rem 1rem;
  min-height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

/* ===== آیکون ===== */
.stat-icon {
  font-size: 2rem;
  margin-bottom: 0.4rem;
  opacity: 0.9;
  line-height: 1;
}

/* ===== عدد ===== */
.stat-number {
  font-size: 2.4rem;
  font-weight: 800;
  color: white;
  margin-bottom: 0.4rem;
  line-height: 1.2;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* ===== برچسب ===== */
.stat-label {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* ========================================== */
/* باکس پیامک (ویژه) */
/* ========================================== */
.sms-card-body {
  padding-bottom: 1.2rem !important;
}

.sms-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 0.4rem;
}

.sms-number {
  font-size: 2.2rem;
  margin-bottom: 0.3rem;
}

/* ===== بج وضعیت ===== */
.sms-status-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.sms-status-success {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  backdrop-filter: blur(4px);
}

.sms-status-warning {
  background: rgba(255, 193, 7, 0.9);
  color: #ffffff;
}

.sms-status-danger {
  background: rgba(220, 53, 69, 0.9);
  color: #ffffff;
}

/* ===== دکمه شارژ ===== */
.btn-charge-sms {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 0.8rem;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.95);
  color: #0d6efd;
  border: none;
  border-radius: 24px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  width: 100%;
  max-width: 200px;
}

.btn-charge-sms:hover {
  background: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.btn-charge-sms:active {
  transform: translateY(0);
}

.btn-charge-sms svg {
  flex-shrink: 0;
}

/* ========================================== */
/* ریسپانسیو */
/* ========================================== */
@media (max-width: 768px) {
  .stat-number {
    font-size: 1.8rem;
  }

  .sms-number {
    font-size: 1.8rem;
  }

  .stat-label {
    font-size: 0.8rem;
  }

  .stat-card .card-body {
    padding: 1.2rem 0.8rem;
    min-height: 150px;
  }

  .stat-icon {
    font-size: 1.6rem;
  }

  .btn-charge-sms {
    font-size: 0.75rem;
    padding: 6px 14px;
  }
}

@media (max-width: 576px) {
  .stat-number {
    font-size: 1.6rem;
  }

  .sms-number {
    font-size: 1.6rem;
  }

  .stat-label {
    font-size: 0.75rem;
  }

  .stat-card .card-body {
    min-height: 130px;
    padding: 1rem 0.6rem;
  }

  .stat-icon {
    font-size: 1.4rem;
  }

  .sms-status-badge {
    font-size: 9px;
    padding: 1px 8px;
  }

  .btn-charge-sms {
    font-size: 0.7rem;
    padding: 5px 10px;
    margin-top: 0.6rem;
  }
}
</style>